import { Link, Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import { LayoutByInformation } from "./Layout";

/**
 * @property {import("@raiden/library/types/Configuration").ConfigurationEnvironment} environment
 */
export function PersonnalInformation({ environment }) {
  return (
    <>
      <LayoutByInformation icon="ms_place">
        <Text as="div">
          <Link
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              `${environment.company_name}, ${environment.zipcode}`,
            )}`}
            target="_blank">
            <FormattedMessage
              defaultMessage={`<text>{company_name}</text> <text>{address}</text> {zipcode} {city}`}
              values={{
                company_name: environment.company_name,
                address: environment.address_2
                  ? `${environment.address_1}, ${environment.address_2}`
                  : environment.address_1,
                zipcode: environment.zipcode,
                city: environment.city,
                text: (text) => {
                  return <Text>{text}</Text>;
                },
              }}
            />
          </Link>
        </Text>
      </LayoutByInformation>

      <LayoutByInformation icon="ms_schedule">
        <Text whiteSpace="pre-line">{environment.infos}</Text>
      </LayoutByInformation>

      {environment.phone_number && (
        <LayoutByInformation icon="ms_phone">
          <Text fontWeight={500} fontSize="1.125rem">
            <Link
              href={`tel:${environment.phone_number}`}
              display="inline-block">
              {environment.phone_number
                .replace("+33", "0")
                .replace(/(..)/g, "$1 ")}
            </Link>
          </Text>
        </LayoutByInformation>
      )}

      {environment.email && (
        <LayoutByInformation icon="ms_mail">
          <Text fontWeight={500} fontSize="1.125rem">
            <Link href={`mailto:${environment.email}`} target="_blank">
              {environment.email}
            </Link>
          </Text>
        </LayoutByInformation>
      )}
    </>
  );
}
